import { useEffect, useState } from "react";
import EditIcon from "@material-ui/icons/Edit";
import AttendeesSelect from "../../commons/selects/AttendeesSelect";
import { ListedUser } from "../../users/listedUser.model";
import {
  UserDialogActions,
  UserDialogContent,
  UserDialogTitle,
  useUserDialogStyle,
} from "../../commons/dialog/UserDialog";
import { Button, Dialog, Grid, Typography } from "@material-ui/core";

type Props = {
  open: boolean;
  attendees: ListedUser[];
  onSave: (attendees: ListedUser[]) => void;
  onClose: () => void;
};

export const BookingUpdateAttendeesDialog: React.FC<Props> = ({
  attendees,
  open,
  onClose,
  onSave,
}) => {
  const dialogClasses = useUserDialogStyle();
  const [selectedAttendees, setSelectedAttendees] =
    useState<ListedUser[]>(attendees);

  useEffect(() => {
    setSelectedAttendees(attendees);
  }, [attendees]);

  const handleOnSave = () => {
    console.log("Selected attendees:", selectedAttendees);
    onSave(selectedAttendees);
  };

  const handleAttendeesChange = (attendees: ListedUser[]) => {
    setSelectedAttendees(attendees);
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        maxWidth={"sm"}
        fullWidth={true}
        classes={dialogClasses}
      >
        <UserDialogTitle
          id="customized-dialog-title"
          onClose={onClose}
          background="owner"
        >
          <Typography variant="h6">Actualizar invitados</Typography>
        </UserDialogTitle>
        <UserDialogContent dividers>
          <AttendeesSelect
            value={selectedAttendees}
            onChange={handleAttendeesChange}
          ></AttendeesSelect>
        </UserDialogContent>
        <UserDialogActions>
          <Grid container justifyContent="flex-end">
            <Grid item xs={4}>
              <Button
                autoFocus
                color="secondary"
                variant="contained"
                fullWidth
                startIcon={<EditIcon />}
                onClick={handleOnSave}
              >
                Actualizar
              </Button>
            </Grid>
          </Grid>
        </UserDialogActions>
      </Dialog>
    </>
  );
};
